/**
 * Rubina Irfan — Money formatting
 *
 * Single source of truth for turning cents into a display price client-side.
 * Mirrors Shopify's server-side `money` filter exactly, so an AJAX-updated
 * price is always identical to the one Liquid rendered on page load.
 *
 * Two things the old per-file copies got wrong:
 *   1. No thousands separators — `{{amount}}` DOES get them server-side, so
 *      "Rs1,449,900.00" turned into "Rs. 1449900.00" after any cart update.
 *   2. `shop.money_format` can contain markup (this shop uses
 *      "<span class=money>Rs{{amount}}</span>"). Callers that write the result
 *      with textContent must use `RIMoney.text()` so the tags don't show up
 *      literally on screen.
 *
 * Loaded deferred from <head>, so it is always defined before any other
 * deferred/DOMContentLoaded code runs.
 */
window.RIMoney = (function () {
  'use strict';

  var DEFAULT_FORMAT = 'Rs{{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;

    if (isNaN(number) || number == null) return '0';

    number = (number / 100).toFixed(precision);

    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var fraction = parts[1] ? decimal + parts[1] : '';

    return whole + fraction;
  }

  /* Returns the price with whatever markup money_format carries. */
  function format(cents, formatString) {
    var format = formatString || shopFormat();

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    if (!match) return format;

    var value;
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
  }

  /* Same value with any markup stripped — safe for textContent. */
  function text(cents, formatString) {
    return format(cents, formatString).replace(/<[^>]*>/g, '');
  }

  function shopFormat() {
    return (window.Shopify && window.Shopify.money_format) || DEFAULT_FORMAT;
  }

  return { format: format, text: text };
})();
